import { type WorkflowId } from '@blaze-shared/api-contracts-domain';
import { type WorkflowNode } from '@blaze-shared/workflow-domain';

import { type BaseWorkflowNode, NodeRegistry } from '../registry/node.registry';

export class WorkflowNodeFactory {
  static createNode<T extends WorkflowNode>(node: T, workflowId: WorkflowId): BaseWorkflowNode<T> {
    const nodeClass = NodeRegistry.getNode(node.nodeType);

    return new nodeClass(node, workflowId) as BaseWorkflowNode<T>;
  }
}
